import script from "./RecipeListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecipeListView.vue?vue&type=script&lang=ts&setup=true"

import "./RecipeListView.vue?vue&type=style&index=0&id=f0f50300&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0f50300"]])

export default __exports__